import { RestrictionTypes } from "./enums/restriction-types";

export class Restriction {
  public id: string;
  public organizationId: string;
  public extensionId: string;
  public calendarId: string;
  public name: string;
  public enabled: boolean;
  public type: RestrictionTypes;
  public expression: string;
}
